import { EventEmitter } from 'Bundles/InterfaceBundle/services/EventEmitter'

export const FormEvents = {
	submitted: new EventEmitter(),
	ready: new EventEmitter(),
	disableRouting: false,
	activeForms: [],
	activeFormChange: new EventEmitter()
}